import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type CreateThreadMutationVariables = Types.Exact<{
   params: Types.CreateThreadParams
}>

export type CreateThreadMutation = {
   __typename?: 'Mutation'
   createThread:
      | {
           __typename?: 'CreateThreadResult'
           thread: { __typename?: 'Thread'; threadId: number; name: string }
        }
      | { __typename?: 'ThreadEntityNotFound' }
}

export const CreateThreadDocument = gql`
   mutation CreateThread($params: CreateThreadParams!) {
      createThread(params: $params) {
         ... on CreateThreadResult {
            thread {
               threadId
               name
            }
         }
      }
   }
`
export type CreateThreadMutationFn = Apollo.MutationFunction<
   CreateThreadMutation,
   CreateThreadMutationVariables
>
export type CreateThreadMutationResult = Apollo.MutationResult<
   CreateThreadMutation
>
export type CreateThreadMutationOptions = Apollo.BaseMutationOptions<
   CreateThreadMutation,
   CreateThreadMutationVariables
>
